import { stringify } from "query-string";

const filtersEndPoint = "/tennis/api/PlayerApi/GetMostTitledFilters";
const playersEndPoint = "/tennis/api/PlayerApi/GetMostTitledPlayers";

export async function getMostTitledPlayers(params: Record<string, string>) {
  try {
    const response = await fetch(
      `${process.env.HOST}${playersEndPoint}?${stringify(params)}`
    );
    if (response.ok) {
      return await response.json();
    } else {
      throw Error(response.statusText);
    }
  } catch {
    throw Error("Something went wrong");
  }
}

export async function getMostTitledFilters(circuitCode: string) {
  try {
    const response = await fetch(
      `${process.env.HOST}${filtersEndPoint}?circuitCode=${circuitCode}`
    );
    if (response.ok) {
      return await response.json();
    } else {
      throw Error(response.statusText);
    }
  } catch {
    throw Error("Something went wrong");
  }
}
